/**
 * BOTTOM GENERAL INITS
 * POLL
 */

import { Poll } from "./poll";


export class PollInits {
    constructor() {
        this.initMap();
    }

    initMap() {
        new Poll();
    }
}
